import Table from 'components/molecules/Table/Table'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import {
    hideSrpInventoryPage,
    isArrayIncludesAny, isArrayNotEmpty,
    isCompletedHotelInfoHistory, isObjectEmpty, searchFirstObjectInList
} from 'utilities/JSUtil'
import * as FormConst from '../../../../constants/FormConst'
import * as RoleConfigurationConst from '../../../../constants/RoleConfigurationConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import withFormLayout from '../WithFormLayout'
import './Rateplans.scss'

export class Rateplans extends Component {

    constructor(props) {
        super(props)

        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const user = getSessionItem(SessionConst.USER)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode || !hotelInfo || !user) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        const isHotelContact = user.isHotelContact

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            hotelText: [],
            error: undefined,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            rateplanPageStatus: this.rateplanPageStatus,
            isHotelContact: isHotelContact,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    headers = ['Rateplan Form', 'Status', 'Action']

    rateplanPageStatus = {
        'BOX_INVENTORY': 'Pending',
        'SRP_INVENTORY': 'Pending',
        'OTA_RATE_PROGRAMS': 'Pending',
        'RATE_PLANS': 'Pending',
        'BLACK_OUTS': 'Pending'
    }

    rateplanPageRoutes = {
        'BOX_INVENTORY': RouteConst.ROUTE_BOX_INVENTORY_PAGE,
        'SRP_INVENTORY': RouteConst.ROUTE_SRP_INVENTORY_PAGE,
        'OTA_RATE_PROGRAMS': RouteConst.ROUTE_OTA_RATE_PROGRAMS_PAGE,
        'RATE_PLANS': RouteConst.ROUTE_OTHER_RATEPLANS_PAGE,
        'BLACK_OUTS': RouteConst.ROUTE_RATEPLAN_BLACKOUTS_PAGE
    }

    rateplanPageLabels = {
        'BOX_INVENTORY': 'Box Inventory',
        'SRP_INVENTORY': 'SRP Inventory',
        'OTA_RATE_PROGRAMS': 'Third Party Rate Programs',
        'RATE_PLANS': 'Other Rate Plans',
        'BLACK_OUTS': 'Rateplan Blackouts'
    }

    async componentDidMount() {
        if (isArrayNotEmpty(this.props.checklist)) {
            this.updateStatusFromChecklist()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.errorMessage) {
            this.setState({
                isLoading: false,
                showErrorModal: true,
                errorMessage: this.props.errorDescription
            })
        } else if (JSON.stringify(prevProps.checklist) !== JSON.stringify(this.props.checklist)) {
            this.updateStatusFromChecklist()
        }
    }

    updateStatusFromChecklist = () => {
        let boxInventoryStatus = 'Pending'
        let srpInventoryStatus = 'Pending'
        let otaRateProgramsStatus = 'Pending'
        let otherRateplansStatus = 'Pending'
        let blackoutsStatus = 'Pending'
        let checklist = this.props.checklist
        if (isArrayNotEmpty(checklist)) {
            const boxInventoryObject = searchFirstObjectInList('code', 'BOX_INVENTORY', checklist)
            const srpInventoryObject = searchFirstObjectInList('code', 'SRP_INVENTORY', checklist)
            const otaRateProgramsObject = searchFirstObjectInList('code', 'OTA_RATE_PROGRAMS', checklist)
            const otherRateplansObject = searchFirstObjectInList('code', 'RATE_PLANS', checklist)
            const blackoutsObject = searchFirstObjectInList('code', 'BLACK_OUTS', checklist)
            const hideSrpInventory = hideSrpInventoryPage(this.state.hotelInfoCompletedHistory, checklist)

            let completedRateplanPages = 0
            let expectedNumberOfPages = hideSrpInventory ? 4 : 5
            let availableRateplanPageStatus = { ...this.rateplanPageStatus }

            if (boxInventoryObject?.processedFlag === 'COMPLETED') {
                availableRateplanPageStatus.BOX_INVENTORY = 'Complete'
                completedRateplanPages++
            }

            if (hideSrpInventory) {
                delete availableRateplanPageStatus.SRP_INVENTORY
            } else if (srpInventoryObject?.processedFlag === 'COMPLETED') {
                availableRateplanPageStatus.SRP_INVENTORY = 'Complete'
                completedRateplanPages++
            }

            if (otaRateProgramsObject?.processedFlag === 'COMPLETED') {
                availableRateplanPageStatus.OTA_RATE_PROGRAMS = 'Complete'
                completedRateplanPages++
            }
            if (otherRateplansObject?.processedFlag === 'COMPLETED') {
                availableRateplanPageStatus.RATE_PLANS = 'Complete'
                completedRateplanPages++
            }
            if (blackoutsObject?.processedFlag === 'COMPLETED') {
                availableRateplanPageStatus.BLACK_OUTS = 'Complete'
                completedRateplanPages++
            }

            this.setState({
                rateplanPageStatus: availableRateplanPageStatus,
                isSectionComplete: completedRateplanPages === expectedNumberOfPages,
                proceedButtonName: completedRateplanPages === expectedNumberOfPages
                    ? this.state.isHotelContact ? 'Go to Submit page' : 'Go to Manage Record'
                    : completedRateplanPages > 0 ? 'Continue Editing' : 'Start Editing',
                isLoading: false
            })
        }
    }

    onClickActionButton = () => {
        // Get the first pending item
        if (!this.state.isSectionComplete) {
            let selectedType = 'BOX_INVENTORY'
            for (const type in this.state.rateplanPageStatus) {
                if (this.state.rateplanPageStatus.hasOwnProperty(type)) {
                    const status = this.state.rateplanPageStatus[type];
                    if (status === 'Pending') {
                        selectedType = type
                        break
                    }
                }
            }
            // Go to the page
            this.props.history.push({
                pathname: this.rateplanPageRoutes[selectedType],
                state: {
                    continueFlow: true
                }
            })
        } else {
            // This section is complete. Proceed to the submit page for Hotel COntact,
            // Manage Record page for Admins
            if (this.state.isHotelContact) {
                this.props.history.push(RouteConst.ROUTE_SUBMIT_FOR_REVIEW_PAGE)
            } else {
                this.props.history.push(RouteConst.ROUTE_FEEDBACK_PAGE)
            }
        }
    }

    render() {

        let tableData = []

        for (const type in this.state.rateplanPageStatus) {
            const status = this.state.rateplanPageStatus[type]
            if (this.state.rateplanPageStatus.hasOwnProperty(type)) {
                tableData.push([this.rateplanPageLabels[type], status, <NavLink to={this.rateplanPageRoutes[type]}>{status === 'Complete' ? 'Edit' : 'Add'}</NavLink>])
            }
        }

        return (
            <div className='rateplans-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Rateplans</li>
                    </ol>
                </nav>
                <p>This section is to submit Rateplan information.</p>
                {
                    !this.state.isLoading
                    && (
                        <Table bordered striped headers={this.headers} data={tableData} className='rateplan-pages-table' />
                    )
                }
                {
                    this.state.isSectionComplete
                    && this.state.isHotelContact
                    && (
                        <div className="alert alert-success" role="alert">
                            <h4 className="alert-heading">Well done!</h4>
                            <p>You successfully finished this module. Let's proceed to the <NavLink to={SideNavEntryMapping.SUBMIT_FOR_REVIEW.current.route} className='alert-link'>next</NavLink> module</p>
                        </div>
                    )
                }
                <FormFooter
                    form={SideNavEntryMapping.RATE_PLANS}
                    submitName={this.state.proceedButtonName}
                    onSubmit={this.onClickActionButton}
                    noReset />
            </div>
        )
    }
}

export default withFormLayout(Rateplans, SideNavEntryMapping.RATE_PLANS)